import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FileInfoType } from '@schoolbelle/api/file';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MediaBrowserModalComponent } from './media-browser-modal.component';

@Injectable()
export class MediaBrowserModalService {
  constructor(
    private modal : BsModalService,
  ){
  }
  open(list:FileInfoType[], index = 0):Observable<any> {
    const modal:BsModalRef = this.modal.show(MediaBrowserModalComponent, {class:'modal-fullsize', initialState:{list, index}});
    return modal.content.action.pipe(take(1))
  }
}
